module.exports = __webpack_public_path__ + "img/C7C0AC_2E181B_543B30_6B6270-256px.7e338ebe.png";